<template>
  <v-dialog :value="value" @input="(aberto) => $emit('input', aberto)" width="520" persistent>
    <v-card>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(encerrar)">
          <v-card-title class="text-h6">Encerrar Caso</v-card-title>

          <v-card-text>
            <v-alert type="info" text dense border="left" class="text-body-2">
              O histórico de ações é preservado. O aluno sai da listagem de risco e só volta a
              aceitar novos acompanhamentos se apresentar risco de evasão outra vez, contando apenas
              as faltas lançadas a partir de hoje.
            </v-alert>

            <e-label>Justificativa do encerramento</e-label>
            <ValidationProvider name="Justificativa" rules="required" v-slot="{ errors }">
              <v-textarea
                :error-messages="errors"
                v-model="justificativa"
                rows="4"
                counter="1000"
                maxlength="1000"
                placeholder="Explique por que o caso está sendo encerrado"
                dense
                solo
              />
            </ValidationProvider>
          </v-card-text>

          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn color="secondary" type="button" small @click="fechar">Cancelar</v-btn>
            <v-btn color="error" type="submit" :loading="salvando" small>Encerrar Caso</v-btn>
          </v-card-actions>
        </form>
      </ValidationObserver>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EModalEncerrarCaso",
  props: {
    value: { type: Boolean, default: false },
    casoId: { type: [Number, String], required: true },
  },
  data() {
    return {
      justificativa: "",
      salvando: false,
    };
  },
  watch: {
    value(aberto) {
      if (aberto) {
        this.justificativa = "";
      }
    },
  },
  methods: {
    fechar() {
      this.$emit("input", false);
    },
    async encerrar() {
      this.salvando = true;
      try {
        const resposta = await this.$services.buscaAtivaService.encerrarCaso(
          this.casoId,
          this.justificativa
        );
        this.$toast.success("Caso encerrado");
        this.$emit("encerrado", resposta);
        this.fechar();
      } catch (error) {
        this.$handleError(error);
      }
      this.salvando = false;
    },
  },
};
</script>
